import React, { useState, useEffect } from "react";
import { FaArrowLeftLong } from "react-icons/fa6";
import { useNavigate, useParams } from "react-router-dom";
import { axiosInstance } from "../../../axiosInstance";
import { useFormik } from "formik";
import { object, string } from "yup";
import { toast } from "react-toastify";

const validationSchema = object().shape({
  first_name: string().required("First Name is required"),
  last_name: string().required("Last Name is required"),
  mobile_no: string().required("mobile no is required"),
});

export const RetailerEachSubUser = () => {
  const [loading, setLoading] = useState(false);
  const { retailersubuser_id } = useParams();
  const navigate = useNavigate();

  const RetailerId = localStorage.getItem("retailer_id");
  console.log("Retailer Id:", RetailerId);

  const formik = useFormik({
    initialValues: {
      first_name: "",
      last_name: "",
      email: "",
      mobile_no: "",
      is_active: true,
    },
    validationSchema,
    onSubmit: async (values) => {
      setLoading(true);
      try {
        const payload = {
          first_name: values.first_name.trim(),
          last_name: values.last_name.trim(),
          email: values.email.trim(),
          mobile_no: values.mobile_no,
          is_active: values.is_active,
        };

        const response = await axiosInstance.put(
          `/admin/retailer-subuser/${retailersubuser_id}/`,
          payload
        );

        if (response.data.status === "success") {
          toast.success("Retailer sub user updated successfully!");
          setTimeout(
            () => navigate(`/manage-retailer-edit/${RetailerId}`),
            1500
          );
        } else {
          toast.error(response.data.message || "Failed to update Retailer.");
        }
      } catch (err) {
        console.error("❌ Error updating Retailer:", err);
        toast.error("Something went wrong. Please try again.");
      } finally {
        setLoading(false);
      }
    },
  });

  const handleCancel = () => {
    navigate(`/manage-retailer-edit/${RetailerId}`);
  };

  useEffect(() => {
    const fetchRetailerSubUserDetails = async () => {
      try {
        const res = await axiosInstance.get(
          `/admin/retailer-subuser/${retailersubuser_id}`
        );
        if (res.data.status === "success" && res.data.data) {
          formik.setValues({
            first_name: res.data.data.first_name || "",
            last_name: res.data.data.last_name || "",
            email: res.data.data.email || "",
            mobile_no: res.data.data.mobile_no || "",
            is_active: res.data.data.is_active ?? true,
          });
        } else {
          toast.error("Failed to load Retailer sub user details.");
        }
      } catch (err) {
        console.error("Error fetching Retailer sub user data:", err);
        toast.error(
          "Something went wrong while loading Retailer sub user data."
        );
      }
    };

    fetchRetailerSubUserDetails();
  }, [retailersubuser_id]);

  return (
    <form onSubmit={formik.handleSubmit}>
      <div className="addAdmin-container">
        <div className="addAdmin-subcontainer">
          <FaArrowLeftLong
            style={{ cursor: "pointer" }}
            onClick={() => {
              navigate(`/manage-retailer-edit/${RetailerId}`);
            }}
          />
          <div className="add-title">Edit Sub User</div>
        </div>
        <div className="addAdmin-content">
          <div className="addAdmin-contentLeft">
            <div className="addAdmin-field">
              <label>
                <span className="text-danger">*</span> First Name
              </label>
              <div>
                <input
                  type="text"
                  name="first_name"
                  placeholder="Enter Your First Name"
                  value={formik.values.first_name}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                />
                {formik.touched.first_name && formik.errors.first_name && (
                  <div className="text-danger">{formik.errors.first_name}</div>
                )}
              </div>
            </div>
            <div className="addAdmin-field">
              <label>Email</label>
              <div>
                <input
                  type="text"
                  name="email"
                  placeholder="Enter Your Email id"
                  value={formik.values.email}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                />
              </div>
            </div>
          </div>
          <div className="addAdmin-contentRight">
            <div className="addAdmin-field">
              <label>
                <span className="text-danger">*</span> Last Name
              </label>
              <div>
                <input
                  type="text"
                  name="last_name"
                  placeholder="Enter Your Last Name"
                  value={formik.values.last_name}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                />
                {formik.touched.last_name && formik.errors.last_name && (
                  <div className="text-danger">{formik.errors.last_name}</div>
                )}
              </div>
            </div>

            <div className="addAdmin-field">
              <label>
                <span className="text-danger">*</span>Mobile No
              </label>
              <div>
                <input
                  type="text"
                  name="number"
                  placeholder="Enter Your mobile no"
                  value={formik.values.mobile_no}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                />
                {formik.touched.mobile_no && formik.errors.mobile_no && (
                  <div className="text-danger">{formik.errors.mobile_no}</div>
                )}
              </div>
            </div>
          </div>
        </div>
        <div className="addbtnContainer">
          <div>
            <button
              type="button"
              className="whole-btnCancel"
              onClick={handleCancel}
              disabled={loading}
            >
              Cancel
            </button>
          </div>
          <div>
            <button
              type="submit"
              className="whole-btnUpdate"
              disabled={loading}
            >
              {loading ? "Updating..." : "Update"}
            </button>
          </div>
        </div>
      </div>
    </form>
  );
};
